import { useApiClient } from "../../../apiClient";

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CoachDto } from "../../../models/coach/dto/coach.dto";
import { UpdateCoachInputDto, UpdateCoachOutputDto } from "../../../models/coach/dto/update-coach.dto";
import { GET_COACH_QUERY_KEY } from "./useGetCoach";
import { GET_COACH_ADMIN_QUERY_KEY } from "./useGetCoachAdmin";

export const useUpdateCoach = (id: string, onSuccess: () => void) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['updateCoach'],
        mutationFn: async (input: UpdateCoachInputDto) => {
            const response = await apiClient.fetchApi<UpdateCoachOutputDto, UpdateCoachInputDto>({ method: 'PUT', endpoint: `coachs/${id}`, body: input });
            return response
        },
        onSuccess: (response) => {
            queryClient.setQueryData<CoachDto>(GET_COACH_QUERY_KEY(id), response);
            // MYS-75 (D1): an admin's PUT answers with the admin shape, which is
            // the only one carrying `isPhonePublic`. A coach-self PUT answers with
            // the public shape and must not overwrite the admin read.
            if ('isPhonePublic' in response) {
                queryClient.setQueryData(GET_COACH_ADMIN_QUERY_KEY(id), response);
            }
            onSuccess();
        }
    });
};